import { render, staticRenderFns } from "./MaterialEventsListModal.vue?vue&type=template&id=30415c48&"
import script from "./MaterialEventsListModal.vue?vue&type=script&lang=js&"
export * from "./MaterialEventsListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports